import { DiscountProductDetail } from '@/entities/catalog-discount/schema/discount-product-detail.schema'
import { DiscountProductPrice } from '@/entities/catalog-discount/schema/discount-product.schema'

import { OrderType, TPrice, TProduct } from '@/shared/types/product-types'

const toPrice = (price?: DiscountProductPrice | number): TPrice => {
	if (price == null) {
		return { VALUE: 0 }
	}

	if (typeof price === 'number') {
		return { VALUE: price }
	}

	return {
		VALUE: price.VALUE,
		PRICE_TYPE: price.PRICE_TYPE
	}
}

export const mapDiscountProductDetailToProduct = (item: DiscountProductDetail): TProduct => {
	const kod = String(item.KOD)
	const sectionId = item.SECTION_ID != null ? Number(item.SECTION_ID) : undefined
	const images = item.IMAGES ?? []

	return {
		ID: Number(item.ID),
		KOD: kod,
		TITLE: item.TITLE ?? '',
		PRICE: toPrice(item.PRICE),
		OLD_PRICE: item.OLD_PRICE != null ? toPrice(item.OLD_PRICE) : undefined,
		ORDER_TYPE: item.ORDER_TYPE as OrderType,
		IMAGES: images,
		IMAGE: images[0],
		PROPERTIES: item.PROPERTIES ?? {},
		SEO: item.SEO,
		SECTION_ID: sectionId,
		SECTION_CODE: item.SECTION_CODE,
		SECTION_NAME: item.SECTION_NAME,
		SECTIONS: sectionId != null ? [String(sectionId)] : [],
		VISIBLE_PRICE: true,
		PROMOTION: [],
		HAS_ACCESSORIES: false,
		HAS_SERVICES: false
	}
}
